.mymachine-overview {
    &__cta-buttons-container {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        margin-bottom: 10px;

        @media only screen and (min-width: 768px) {
            flex-direction: row;
            flex-wrap: wrap;
        }

        @media only screen and (min-width: 1024px) {
            margin-top: 10px;
        }
    }

    .mymachine-overview__button-direct-search {
        display: none;

        @media only screen and (min-width: $tablet) {
            display: block;
        }

        @media only screen and (min-width: $desktop-s) {
            margin-left: auto;
        }
    }

    &__cta-buttons-container > * {
        min-width: 100%;
        margin-bottom: 15px;

        @media only screen and (min-width: 768px) {
            min-width: auto;
            margin-right: 20px;
        }
    }

    .mymachine-overview__direct-search-element {
        order: -1;
        margin-bottom: 0;
        margin-left: auto;

        @media only screen and (min-width: 768px) {
            min-width: 100%;
        }

        @media only screen and (min-width: $tablet) {
            display: none;
            order: 1;
        }
    }

    &__filter-container {
        @include clearfix;

        .ux-label {
            min-width: auto;
            padding-right: 20px;
        }
    }

    &__filter-dropdown {
        min-width: 250px;
        position: relative;
        margin-bottom: 10px;

        @media only screen and (min-width: 768px) {
            max-width: 300px;
            display: inline-block;
            margin-right: 18px;
        }
    }

    &__filter-checkboxes {
        display: inline-block;
        margin-bottom: 20px;

        @media only screen and (max-width: 1070px) {
            display: block;
            margin: 10px 0 20px;
        }
    }

    &__filter-checkbox {
        &:not(:last-child) {
            margin-right: 15px;
        }
    }

    .ux-button-group {
        @include legacy-gridle-state(dlarge) {
            position: absolute;
            right: 0;
            top: 0;
        }

        @include legacy-gridle-state(mt) {
            float: right;
            margin-left: 25px;
        }
    }

    &__result-set {
        position: relative;

        @include legacy-gridle-state(large) {
            text-align: center;
        }

        @include legacy-gridle-state(mtd) {
            text-align: left;
        }
    }

    &__sort {
        font-size: 16px;
        background-color: $color-white;

        @include legacy-gridle-state(dlarge) {
            position: absolute;
            right: 115px;
            top: 0;
        }

        @include legacy-gridle-state(mt) {
            float: right;
            margin-bottom: 0;
            margin-left: 25px;
        }

        @include legacy-gridle-state(m) {
            margin-top: 30px;
        }
    }

    &__tiles-container {
        max-width: 100%;
        margin: 0 auto;

        .ux-tile {
            max-width: none;
            margin-bottom: 30px;
        }

        .ux-tile-body {
            overflow: hidden;
        }
    }

    &__table-container {
        .ux-iws-async-toggle-button {
            font-size: 21px;
        }
    }
}
